import { render } from "./Index.vue?vue&type=template&id=240c7fd5"
const script = {}
script.render = render

export default script